<div class="flex flex-grow flex-col gap-y-4 p-4 md:py-4 md:pl-4 md:pr-6">
  <ng-content></ng-content>
</div>
<div
  [class.hidden]="isCollapsed$$()"
  [ngStyle]="{ 'background-image': 'url(images/residential/' + serviceCode$$() + '.webp)' }"
  class="h-[184px] w-full flex-shrink-0 rounded-3xl bg-cover bg-[20%_center] md:h-auto md:min-h-[168px] md:max-w-[180px]"
></div>
